import styled from 'styled-components';

import { layoutSizes, responsive, sp } from '@main/theme';

/**
 * The DataSubjectRequestForm wrapper
 */
export const DataSubjectRequestFormWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  ${responsive.beforeTablet} {
    margin-top: ${layoutSizes.mobile.msp()};
  }
  ${responsive.atLeastTablet} {
    margin-top: ${layoutSizes.tablet.msp()};
  }
  ${responsive.atLeastDesktop} {
    margin-top: ${layoutSizes.desktop.msp()};
  }
`;

export const RequiredWrapper = styled.span`
  color: ${({ theme }) => theme.colors.red1};
  padding-left: 3px;
`;

/**
 * Wrapper
 */
export const PostCompileWrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

/**
 * The wrapper for the Region Selection Dropdown
 */
export const RegionDropdownWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${sp(0.75)};
  border-color: black;
  border: 1px solid black;
`;
